export const TRANSLATIONS = {
  en: {
    patient: 'Patient', age: 'Age', gender: 'Gender', weight: 'Weight',
    bloodGroup: 'Blood Group', bp: 'BP', pulse: 'Pulse', spo2: 'SpO₂',
    rxNo: 'Rx No.', date: 'Date', gestationalAge: 'Gest. Age', edd: 'EDD',
    chiefComplaint: 'Chief Complaint', provisionalDiagnosis: 'Provisional Diagnosis',
    allergy: 'Allergy', medicinesPrescribed: 'Medicines Prescribed',
    medicine: 'Medicine', dosage: 'Dosage', duration: 'Duration', meal: 'Meal',
    adviceGiven: 'Advice Given', investigationsAdvised: 'Investigations Advised',
    medicalNotes: 'Medical Notes', followUpDate: 'Follow-Up Date',
    referToDoctor: 'Refer to Doctor', signature: 'Signature', regNo: 'Reg. No.',
    computerGenerated: 'This prescription is computer generated.',
    day: 'day', days: 'days', yrs: 'yrs',
  },
  hi: {
    patient: 'रोगी', age: 'आयु', gender: 'लिंग', weight: 'वजन',
    bloodGroup: 'रक्त समूह', bp: 'रक्तचाप', pulse: 'नाड़ी', spo2: 'SpO₂',
    rxNo: 'नुस्खा क्र.', date: 'दिनांक', gestationalAge: 'गर्भकालीन आयु', edd: 'प्रसव तिथि',
    chiefComplaint: 'मुख्य शिकायत', provisionalDiagnosis: 'अनुमानित निदान',
    allergy: 'एलर्जी', medicinesPrescribed: 'निर्धारित दवाएं',
    medicine: 'दवा', dosage: 'मात्रा', duration: 'अवधि', meal: 'भोजन',
    adviceGiven: 'दी गई सलाह', investigationsAdvised: 'सुझाई गई जाँचें',
    medicalNotes: 'चिकित्सा नोट्स', followUpDate: 'अगली भेंट की तारीख',
    referToDoctor: 'डॉक्टर को संदर्भित करें', signature: 'हस्ताक्षर', regNo: 'पंजी. क्र.',
    computerGenerated: 'यह नुस्खा कंप्यूटर द्वारा तैयार किया गया है।',
    day: 'दिन', days: 'दिन', yrs: 'वर्ष',
  },
  mr: {
    patient: 'रुग्ण', age: 'वय', gender: 'लिंग', weight: 'वजन',
    bloodGroup: 'रक्त गट', bp: 'रक्तदाब', pulse: 'नाडी', spo2: 'SpO₂',
    rxNo: 'Rx क्र.', date: 'दिनांक', gestationalAge: 'गर्भावस्था वय', edd: 'प्रसूती दिनांक',
    chiefComplaint: 'मुख्य तक्रार', provisionalDiagnosis: 'तात्पुरते निदान',
    allergy: 'ऍलर्जी', medicinesPrescribed: 'निर्धारित औषधे',
    medicine: 'औषध', dosage: 'मात्रा', duration: 'कालावधी', meal: 'जेवण',
    adviceGiven: 'दिलेला सल्ला', investigationsAdvised: 'सुचवलेल्या तपासण्या',
    medicalNotes: 'वैद्यकीय नोंदी', followUpDate: 'पुढील भेटीची तारीख',
    referToDoctor: 'डॉक्टरांकडे संदर्भित करा', signature: 'स्वाक्षरी', regNo: 'नोंदणी क्र.',
    computerGenerated: 'हे प्रिस्क्रिप्शन संगणकाद्वारे तयार केले आहे.',
    day: 'दिवस', days: 'दिवस', yrs: 'वर्षे',
  },
};

export const GENDER_MAP = {
  hi: { Male: 'पुरुष', Female: 'महिला', Other: 'अन्य' },
  mr: { Male: 'पुरुष', Female: 'स्त्री', Other: 'इतर' },
};

export const MEAL_PREF_MAP = {
  hi: {
    'Before Meal': 'भोजन से पहले',
    'After Meal': 'भोजन के बाद',
    'With Meal': 'भोजन के साथ',
    'Empty Stomach': 'खाली पेट',
  },
  mr: {
    'Before Meal': 'जेवणापूर्वी',
    'After Meal': 'जेवणानंतर',
    'With Meal': 'जेवणासोबत',
    'Empty Stomach': 'रिकाम्या पोटी',
  },
};

export const translateGender = (gender, lang) => GENDER_MAP[lang]?.[gender] || gender;
export const translateMealPref = (mealPref, lang) => MEAL_PREF_MAP[lang]?.[mealPref] || mealPref;

export const getLang = (patient) => {
  if (patient?.hindiPrescription) return 'hi';
  if (patient?.marathiPrescription) return 'mr';
  return 'en';
};

export const getT = (patient) => TRANSLATIONS[getLang(patient)] || TRANSLATIONS.en;

export const formatDurationLocalized = (d, t) => {
  if (!d) return '';
  return `${d} ${d === '1' ? t.day : t.days}`;
};

export const dateLocale = (lang) => {
  if (lang === 'hi') return 'hi-IN';
  if (lang === 'mr') return 'mr-IN';
  return 'en-IN';
};
